import axios, { AxiosPromise } from 'axios';
import { IReport } from '../../../@types/model/masterData/report/report';


export default class ReportHttpService {
    public static getReportData() : AxiosPromise<Array<IReport>> {
        return axios.get(`${API_URL}/v1/Report/GetAllWeb`);
    }

    public static addOrUpdateReport(data : IReport) : AxiosPromise<IReport> {
        return axios.post(`${API_URL}/v1/Report/PostReport`, data);
    }

    public static deleteReport(reportId : number) : AxiosPromise<IReport> {
        return axios.delete(`${API_URL}/v1/Report/Delete`, {
            params : { reportId },
        });
    }
}
